export const PRIORITY_TYPES = [
  {
    id: 1,
    label: "Low",
    icon: "PriorityLow",
    color: "hubColors.greenMain",
  },
  {
    id: 2,
    label: "Medium",
    icon: "PriorityMedium",
    color: "hubColors.yellowMain",
  },
  {
    id: 3,
    label: "High",
    icon: "PriorityHigh",
    color: "hubColors.redMain",
  },
  {
    id: 4,
    label: "Expedited",
    icon: "PriorityExpedite",
    color: "hubColors.blueMain",
  },
].reverse();
